<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <!-- brand logo -->
      <router-link
        to="/"
        class="brand-logo d-flex align-center"
      >
        <v-img
          :src="appLogo"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          class="me-3 "
        ></v-img>

        <h2 class="text--primary">
          {{ appName }}
        </h2>
      </router-link>
      <!--/ brand logo -->

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <div class="d-flex justify-center align-center h-full pa-16">
              <v-img
                contain
                max-width="60%"
                :src="require('@/assets/images/illustrations/login.png')"
              ></v-img>
            </div>
          </div>
        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center auth-bg pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Welcome to Clericle Admin! 🎯
                  </p>
                </v-card-text>

                <!-- login form -->
                <v-card-text>
                  <v-form
                    ref="loginForm"
                    @submit.prevent="login"
                  >
                    <v-text-field
                      v-model="email"
                      outlined
                      label="Email"
                      placeholder="email"
                      :rules="[validators.required, validators.emailValidator]"
                      hide-details="auto"
                      class="mb-6"
                    ></v-text-field>

                    <v-text-field
                      v-model="password"
                      outlined
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="Password"
                      placeholder="Password"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      :rules="[validators.required]"
                      hide-details="auto"
                      class="mb-2"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    ></v-text-field>

                    <v-btn
                      block
                      color="primary"
                      type="submit"
                      class="mt-6"
                      :loading="isLoading"
                      :disabled="isLoading"
                    >
                      Login
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref, getCurrentInstance, inject } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import { axios } from '@axios'
import { useRouter } from '@core/utils'
import themeConfig from '@themeConfig'
import encryptionService from '@/services/encryption.service'

export default {
  setup() {
    // Initializers
    const snackbarService = inject('snackbarService')
    const vm = getCurrentInstance().proxy
    const { router } = useRouter()

    // Properties
    const loginForm = ref(null)
    const email = ref(null)
    const password = ref(null)
    const isPasswordVisible = ref(false)
    const isLoading = ref(false)

    // Methods
    const login = () => {
      isLoading.value = true
      const isFormValid = loginForm.value.validate()

      if (!isFormValid) {
        isLoading.value = false

        return
      }

      axios
        .post('/admin_auth/sign_in', { email: email.value, password: password.value })
        .then(response => {
          const permissions = [
            { action: 'read', subject: 'Public' },
            { action: 'read', subject: 'Admin' },
            { action: 'write', subject: 'Admin' },
          ]
          vm.$ability.update(permissions)
          localStorage.setItem('userAbility', encryptionService.encrypt(JSON.stringify(permissions)))
          localStorage.setItem('userData', JSON.stringify(response.data.data))

          router.push('/')
        })
        .catch(error => {
          isLoading.value = false
          snackbarService.error(error.response.data.errors[0])
        })
    }

    return {
      // Properties
      loginForm,
      email,
      password,
      isPasswordVisible,
      isLoading,

      // Others
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      validators: {
        required,
        emailValidator,
      },
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Methods
      login,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>
